<template>
  <c-modal
    v-if="!isMobile"
    :title="title"
    is-close-btn
    :is-show-button="false"
    @close="emit('close')"
  >
    <div class="terms-modal__content" v-html="content"></div>
  </c-modal>

  <c-bottom-sheet v-else :title="title" is-close-button @close="emit('close')">
    <div class="terms-modal__content" v-html="content"></div>
  </c-bottom-sheet>
</template>

<script setup lang="ts">
import { CBottomSheet, CModal } from '@aj-fe/aj-vue-core'

defineProps<{
  title?: string
  content?: string
  isMobile?: boolean
}>()

const emit = defineEmits<{
  close: []
}>()
</script>

<style lang="scss">
.c-bottom-sheet .terms-modal__content {
  padding-bottom: 24px;
}

.terms-modal__content {
  overflow: hidden;
  max-width: 100%;

  * {
    max-width: 100%;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  th,
  td {
    border: 1px solid black;
    padding: 8px;
    font-family: SUIT, sans-serif;
  }

  span {
    font-family: SUIT, sans-serif;
  }

  table {
    max-width: 750px;
    width: 100%;
    display: block;
    overflow-x: auto;
    border-collapse: separate;
    border-spacing: 0;
  }
}
</style>
